import styles from './colorButton.module.css';

export default function ColorButton ({
  label,
  onClick,
  isDisabled = false,
  iconLeft = null,
  iconRight = null,
  className = null
}) {
  return (
    <button
      onClick={onClick}
      type='button'
      className={`${styles.buttonContainer} ${className !== null && className}`}
      disabled={isDisabled}
    >
      {iconLeft != null && iconLeft}
      <p className={styles.buttonText}>{label}</p>
      {iconRight != null && iconRight}
    </button>
  );
}
